import { render } from "./BaseModalFields.vue?vue&type=template&id=4e2ef2d1"
import script from "./BaseModalFields.vue?vue&type=script&lang=js"
export * from "./BaseModalFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__